module.exports = __webpack_public_path__ + "static/media/phone-left.98758613.svg";